import React, { useState } from 'react';
import './Services.css';
import { Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

const Services = () => {
    const [hoveredService, setHoveredService] = useState(null);
    const navigate = useNavigate();

    const services = [
        {
            title: "Digital Marketing",
            description: "Strategies to boost online presence and convert leads.",
            icon: "📈",
            link: 'digital-marketing'
        },
        {
            title: "Software Product Development",
            description: "Scalable software solutions from MVPs to enterprise applications designed to drive growth.",
            icon: "💻",
            link: 'software-development'
        },
        {
            title: "Web Development",
            description: "Fast, secure websites that meet user expectations and market demands.",
            icon: "🌐",
            link: 'web-development'
        },
        {
            title: "Mobile Apps",
            description: "Native and hybrid iOS/Android apps that engage users.",
            icon: "📱",
            link: 'mobile-app-development'
        },
        {
            title: "Team Outsourcing",
            description: "On-demand tech talent that integrates seamlessly with your team.",
            icon: "👥",
            link: 'out-sourcing'
        },
        {
            title: "Graphic Design",
            description: "Visual solutions that communicate your brand identity effectively across all media.",
            icon: "🎨",
            link: 'get-in-touch'
        },
        {
            title: "Online Stores",
            description: "Custom e-commerce solutions with payment integration and inventory management.",
            icon: "🛒",
            link:'eCommerce-development'
        },
        {
            title: "Let's Collaborate",
            description: "We'd love to hear about your next project and show you how we can help.",
            icon: "🤝",
            link: 'get-in-touch'
        }

    ];

    return (
        <div className="services-container">
            <h2 className="services-title">What We Offer</h2>
           
            <div className="services-grid">
                {services.map((service, index) => (
                    <div
                        key={index}
                        className={`service-card ${hoveredService === index ? 'hovered' : ''}`}
                        onMouseEnter={() => setHoveredService(index)}
                        onMouseLeave={() => setHoveredService(null)}
                        onClick={()=> navigate(`/${service.link}`)}
                    >
                        <div className="service-icon">{service.icon}</div>
                        <h3>{service.title}</h3>
                        <div className="service-description">
                            <p>{service.description}</p>
                        </div>
                        <div className="service-line"></div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Services;